import {PropertyTypeConstructor} from '@mintdata/mint-kit/api/properties/PropertySpec';
import {Type} from '@mintdata/mint-kit/api/types/Type';
import {ErrorOrEmpty} from '@mintdata/mint-kit/api/types/Value';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {ACurrency} from '@mintdata/mint-kit/api/values/ACurrency';
import {ADate} from '@mintdata/mint-kit/api/values/ADate';
import {ADateTime} from '@mintdata/mint-kit/api/values/ADateTime';
import {AError} from '@mintdata/mint-kit/api/values/AError';
import {AInteger} from '@mintdata/mint-kit/api/values/AInteger';
import {AIntegerEnum} from '@mintdata/mint-kit/api/values/AIntegerEnum';
import {ANumber} from '@mintdata/mint-kit/api/values/ANumber';
import {AString} from '@mintdata/mint-kit/api/values/AString';
import {ATime} from '@mintdata/mint-kit/api/values/ATime';
import {BaseCoercionUtil} from '@mintdata/mint-kit/impl/coercionUtils/BaseCoercionUtil';
import {ExcelDateTimeUtil} from '@mintdata/mint-kit/impl/coercionUtils/ExcelDateTimeUtil';

export class NumberCoercionUtil extends BaseCoercionUtil
{
    constructor()
    {
        super(Type.Number);
    }

    public toBoolean(from:ANumber):ABoolean | ErrorOrEmpty
    {
        return new ABoolean(from.value !== 0);
    }

    public toCurrency(from:ANumber):ACurrency | ErrorOrEmpty
    {
        return new ACurrency(from.value);
    }

    public toInteger(from:ANumber):AInteger | ErrorOrEmpty
    {
        return new AInteger(Math.round(from.value));
    }

    public toIntegerEnum(from:ANumber, toCtor?:PropertyTypeConstructor<any>):AIntegerEnum | ErrorOrEmpty
    {
        if( !toCtor )
            return new AError('#CANT_COERCE_TO_INTEGER_ENUM');

        const fromValue:AInteger = new AInteger(Math.round(from.value));
        const toValue:AIntegerEnum = (new toCtor()) as AIntegerEnum;

        return new AIntegerEnum(fromValue, toValue.values);
    }

    public toNumber(from:ANumber):ANumber | ErrorOrEmpty
    {
        return new ANumber(from.value);
    }

    public toDate(from:ANumber):ADate | ErrorOrEmpty
    {
        return ExcelDateTimeUtil.excelDateToADate(from.value);
    }

    public toDateTime(from:ANumber):ADateTime | ErrorOrEmpty
    {
        return ExcelDateTimeUtil.excelDateToADateTime(from.value);
    }

    public toTime(from:ANumber):ATime | ErrorOrEmpty
    {
        return ExcelDateTimeUtil.excelTimeToATime(from.value);
    }

    public toString(from:AInteger):AString | ErrorOrEmpty
    {
        return new AString('' + from.value);
    }
}
